import { createRoutine } from 'redux-saga-routines';

export const stopCoolingProcessRoutine = createRoutine(
    'stopCoolingProcessRoutine',
);
export const changeStationsRoutine = createRoutine('changeStations');
